module.exports = __webpack_public_path__ + "static/media/four_four.ab9f1826.png";